import { Injectable, inject } from '@angular/core';
import { CanDeactivate, Router } from '@angular/router';
import { Observable, map, of } from 'rxjs';
import { BaseCard } from '../core/cdk/base-card';
import { ECardCloseResponse } from '../components/card-close-modal/consts';

@Injectable({
  providedIn: 'root',
})
export class CardCanDeactivateGuard implements CanDeactivate<BaseCard> {
  private readonly _router = inject(Router);
  public canDeactivate(component: BaseCard): Observable<boolean> {
    const navigation = this._router.getCurrentNavigation();

    if (navigation?.extras.state?.['skipDeactivateGuard']) {
      return of(true);
    }

    return component.allFormsDirty
      ? component.callModalWindowOnExit().pipe(
          map((value) => {
            if (value === ECardCloseResponse.success) {
              component.saveCard();
            }

            return value !== ECardCloseResponse.cancel;
          })
        )
      : of(true);
  }
}
